import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PlusCircle, MoreHorizontal, MapPin, Users, GraduationCap } from "lucide-react";

const Schools = () => {
  const schools = [
    {
      id: 1,
      name: "Tech Institute",
      location: "San Francisco, CA",
      students: 1250,
      programs: 15,
      status: "Active",
      type: "University"
    },
    {
      id: 2,
      name: "Digital Academy",
      location: "New York, NY",
      students: 850,
      programs: 8,
      status: "Active",
      type: "College"
    },
    {
      id: 3,
      name: "Innovation School",
      location: "Austin, TX",
      students: 620,
      programs: 5,
      status: "Pending",
      type: "Technical Institute"
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Schools Management</h1>
        <Button className="flex items-center gap-2">
          <PlusCircle className="h-4 w-4" />
          Add School
        </Button>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Total Schools
            </CardTitle>
            <GraduationCap className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{schools.length}</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Total Students
            </CardTitle>
            <Users className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {schools.reduce((acc, school) => acc + school.students, 0)}
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Active Programs
            </CardTitle>
            <GraduationCap className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {schools.reduce((acc, school) => acc + school.programs, 0)}
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Partner Schools</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="rounded-md border">
            <div className="grid grid-cols-6 gap-4 p-4 font-medium border-b">
              <div className="col-span-2">School</div>
              <div>Location</div>
              <div>Students</div>
              <div>Status</div>
              <div>Actions</div>
            </div>
            {schools.map((school) => (
              <div key={school.id} className="grid grid-cols-6 gap-4 p-4 border-b last:border-0 items-center">
                <div className="col-span-2">
                  <div className="font-medium">{school.name}</div>
                  <div className="text-sm text-muted-foreground">{school.type}</div>
                </div>
                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4 text-muted-foreground" />
                  {school.location}
                </div>
                <div>{school.students}</div>
                <div>
                  <span className={`px-2 py-1 rounded-full text-xs ${
                    school.status === 'Active' 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-yellow-100 text-yellow-700'
                  }`}>
                    {school.status}
                  </span>
                </div>
                <div>
                  <Button variant="ghost" size="icon">
                    <MoreHorizontal className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Schools;